import { supabase } from './supabase';

const PROJETO = 'desk';

export async function logError(err, ctx = {}) {
    // Sentry wired in Camada 3 — dynamic import is a no-op until @sentry/react is installed
    // eslint-disable-next-line no-empty
    try { const s = await import('@sentry/react'); s.captureException(err, { extra: ctx }); } catch {}
    try {
        await supabase.rpc('log_app_error', {
            p_projeto:  PROJETO,
            p_severity: ctx.severity ?? 'error',
            p_url:      typeof window !== 'undefined' ? window.location.href : null,
            p_message:  err?.message ?? String(err),
            p_stack:    err?.stack   ?? null,
            p_context:  ctx,
        });
    // eslint-disable-next-line no-empty
    } catch {}
    console.error('[orbion]', err, ctx);
}
